// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__ZKhVc","tooltipWpapper":"Tooltip_tooltipWpapper__+6+HE"};